
import { useEffect, useState } from 'react';
import { mergeClassNames } from '../../../utils/commonFunctions'
import './CustomToast.scss'
import { CircularProgress } from '@mui/material';

interface CustomToastProps extends React.HTMLAttributes<HTMLDivElement> {
    type: 'success' | 'error' | 'info' | 'warning' | 'loading';
    icon?: React.ReactNode;
    message: string;
    duration?: number; // in milliseconds
    onClose?: () => void;
    show?: boolean
}

const CustomToast = ({ type, icon, message, duration = 3000, onClose, show = false, ...rest }: CustomToastProps) => {
    const [showToast, setShowToast] = useState(show);

    const toastIcon = type === 'success' ? <i className='fe fe-check' /> : type === 'error' ? <i className='fe fe-x' /> : type === 'info' ? <i className='fe fe-info' /> : type === 'warning' ? <i className='fe fe-alert-triangle' /> : <CircularProgress size={16} color='inherit' />;

    useEffect(() => {
        if (show) return;
        setTimeout(() => {
            setShowToast(false);
            onClose?.();
        }, duration)
    }, [show, duration])

    if (!show && !showToast) return null
    return (
        <div className={mergeClassNames('custom__toast__container', type)} {...rest}>
            <div className="custom__toast__icon">{icon || toastIcon}</div>
            <div className="custom__toast__message">{message}</div>
        </div>
    )
}

export default CustomToast